export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/MyOrdericon.c364153d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};